import React from 'react';
import PageLoader from '../../../common/PageLoader';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Spinner from 'react-bootstrap/Spinner';
import { useDispatch, useSelector } from 'react-redux';
import {
  getPlansListing,
  getWhatIsMyBusiness,
  makePayment,
} from './../../../../Redux/Actions/UserAction';

// import { GaragesCommenHeader } from './GaragesCommenHeader';
import Sidebar from '../../../common/Sidebar/Sidebar';
import { t } from 'i18next';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Modal } from 'bootstrap';

const API = 'https://api.carsavenue.com/api';

var config = {
  headers: {
    'Content-Type': 'application/json',
    Authorization: sessionStorage.getItem('loged_In_auth'),
  },
};

const BUSINESS_KEYS = {
  CAR01: {
    business: 'sp-spare-parts-business',

    label: t('Manage Parts'),
    service: 'sp-spare-parts-parts',

    banner: 'sp-spare-parts-banner',
    workingHours: 'sp-spare-parts-working-hours',
  },
  CAR02: {
    business: 'sp-garages-business',

    label: t('Manage Services'),
    service: 'sp-garages-services',

    banner: 'sp-garages-banner',
    workingHours: 'sp-garages-working-hours',
  },
  CAR03: {
    business: 'sp-car-dealers-business',

    label: t('Manage Cars'),
    service: 'sp-car-dealers-cars',

    posts: 'sp-car-dealers-cars-post',
    banner: 'sp-car-dealers-banner',
    workingHours: 'sp-car-dealers-working-hours',
  },
  CAR04: {
    business: 'sp-rent-car-business',

    label: t('Manage Cars'),
    service: 'sp-rent-car-cars',

    banner: 'sp-rent-car-banner',
    workingHours: 'sp-rent-car-working-hours',
  },
  CAR06: {
    business: 'sp-car-wash-business',

    label: t('Manage Packages'),
    service: 'sp-car-wash-packages',

    banner: 'sp-car-wash-banner',
    workingHours: 'sp-car-wash-working-hours',
  },
  CAR07: {
    business: 'sp-car-insurance-business',

    label: t('Manage Packages'),
    service: 'sp-car-insurance-packages',

    banner: 'sp-car-insurance-banner',
    workingHours: 'sp-car-insurance-working-hours',
  },
  CAR08: {
    business: 'sp-driving-school-business',

    label: t('Manage Packages'),
    service: 'sp-driving-school-packages',

    banner: 'sp-driving-school-banner',
    workingHours: 'sp-driving-school-working-hours',
  },
  CAR09: {
    business: 'sp-car-protection-business',

    label: t('Manage Packages'),
    service: 'sp-car-protection-packages',

    banner: 'sp-car-protection-banner',
    workingHours: 'sp-car-protection-working-hours',
  },
  CAR10: {
    // Towing is a "lite" category — only a profile page exists (no banner /
    // working-hours / dedicated packages routes). Listing those here created
    // sidebar links to non-existent routes that errored when clicked.
    business: 'sp-car-towing',
  },
  CAR11: {
    business: 'sp-taxi-business',
    // service: 'sp-taxi-car-cars',
    // banner: 'sp-taxi-car-banner',
    // posts: 'sp-taxi-car-post',
    // workingHours: 'sp-taxi-car-working-hours',
  },
  CAR12: {
    business: 'sp-air-conditioning-business',

    label: t('Manage Services'),
    service: 'sp-air-conditioning-services',

    banner: 'sp-air-conditioning-banner',
    workingHours: 'sp-air-conditioning-working-hours',
  },
  CAR13: {
    business: 'sp-quick-services-business',

    label: t('Manage Services'),
    service: 'sp-quick-services-parts',

    banner: 'sp-quick-services-banner',
    workingHours: 'sp-quick-services-working-hours',
  },
  CAR14: 'carAgentId',
};

const BuyPackages = () => {
  const home = useSelector((state) => state?.home);
  const getMybusiness = home?.getMybusiness;
  const getAllPlansList = home?.getAllPlansList;
  // The free plan is a one-time trial granted at business creation. Once the
  // business has any subscription on record (plan_info), the free quota is
  // consumed — the backend rejects re-buying it ("FREE PACKAGE QUOTA
  // UTILIZED"), so we gray out the free card's button to match.
  const freeUsed = !!getMybusiness?.plan_info;
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const [selectedPlan, setSelectedPlan] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState('');
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [loading, setLoading] = useState(false);
  /* [CF 2026-08-17 G4] Set the moment a plan is taken — by card (Tap sends the
     browser back here with ?payment=success) or by claiming the free trial.
     It cannot redirect straight away: `getMybusiness` has to come back first,
     or the section list would render with everything still padlocked. So the
     flag is raised here and the effect below acts on it once the refreshed
     business actually says the sections are unlocked. */
  const [awaitingUnlock, setAwaitingUnlock] = useState(false);

  if (getAllPlansList !== undefined) {
    var objArray = [];
    Object.keys(getAllPlansList).forEach((key) =>
      objArray.push({
        name: key,
        data: getAllPlansList[key],
      })
    );
  }
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPlansListing());
    dispatch(getWhatIsMyBusiness());

    // When Tap redirects back here after payment it appends ?payment=success
    // (or failed) to the hash route. Show the result and refresh the
    // subscription so the new plan/validity reflects immediately.
    const hash = window.location.hash || '';
    const qIndex = hash.indexOf('?');
    if (qIndex !== -1) {
      const params = new URLSearchParams(hash.slice(qIndex + 1));
      const payment = params.get('payment');
      if (payment === 'success') {
        Swal.fire({ title: 'Payment successful', icon: 'success' });
        dispatch(getWhatIsMyBusiness());
        // [CF 2026-08-17 G4] See `awaitingUnlock` below — the return to the
        // section list waits for the refreshed business, not for this line.
        setAwaitingUnlock(true);
      } else if (payment === 'failed') {
        Swal.fire({ title: 'Payment failed or cancelled', icon: 'error' });
      }
      if (payment) {
        // Clean the query off the URL so a refresh doesn't re-trigger the toast.
        window.history.replaceState(null, '', hash.slice(0, qIndex));
      }
    }
  }, [dispatch]);

  /* [CF 2026-08-17 G4] The last step of the owner journey: register → business
     form → package → back to the section list, unlocked. The client's words
     were "without them coming back figuring out and then next and so on".
     Waiting on the same unlock condition the Sidebar uses guarantees the
     sections are open by the time they land, rather than sending them to a
     screen full of padlocks. */
  const unlocked =
    !!getMybusiness?.hasSubscribed || getMybusiness?.daysLeft > 0;
  useEffect(() => {
    if (!awaitingUnlock || !unlocked) return;
    const target = BUSINESS_KEYS[getMybusiness?.businessCode]?.business;
    if (!target) return;
    setAwaitingUnlock(false);
    window.location.href = `#/${target}?hub=1`;
  }, [awaitingUnlock, unlocked, getMybusiness?.businessCode]);

  const paymentRersponse = useSelector((state) => state.home.paymentResponse);
  // const GarageFilterList = home?.GarageFilterList;

  console.log('paymentRersponse', paymentRersponse);

  const handleBuyNowClick = (plan) => {
    const isFree =
      plan?.data?.amount === 0 || plan?.data?.name?.toLowerCase() === 'free';

    if (isFree) {
      dispatch(
        makePayment({
          paymentPlan: plan?.data?.advertisementPackId?.toUpperCase(),
        })
      );
      // The free trial subscribes immediately — same landing as a paid plan.
      setAwaitingUnlock(true);
    } else {
      setSelectedPlan(plan);
      setPaymentMethod('');
      setTermsAccepted(false);
      // Manually open modal (use jQuery since Bootstrap modal is used)
      // Bootstrap 5 native modal open
      const modal = new Modal(document.getElementById('payment-method'));
      modal.show();
    }
  };

  const onPayClickHandler = async () => {
    if (!paymentMethod || !termsAccepted || !selectedPlan) {
      Swal.fire({
        title: 'Please select payment method and accept terms',
        icon: 'warning',
      });
      return;
    }
    setLoading(true);
    try {
      const res = await axios.post(
        `${API}/payment/new`,
        {
          paymentPlan: selectedPlan.data.advertisementPackId,
          paymentMethod: paymentMethod,
        },
        config
      );
      if (res.data.success && res.data.data.url) {
        // Redirect in the SAME tab (not a new tab) so Tap's post-payment
        // redirect lands the user back inside the app instead of stranding them
        // on a separate gateway tab.
        window.location.href = res.data.data.url;
      } else {
        Swal.fire({
          title: 'Payment initiation failed',
          text: res.data.message || 'Please try again.',
          icon: 'error',
        });
      }
    } catch (err) {
      Swal.fire({
        title: 'Error',
        text: err.response?.data?.message || 'Something went wrong.',
        icon: 'error',
      });
    } finally {
      setLoading(false);
      // Bootstrap 5 native modal open
      const modal = new Modal(document.getElementById('payment-method'));
      modal.hide();
    }
  };

  // useEffect(() => {
  //   if (paymentRersponse?.success) {
  //     const isFree =
  //       paymentRersponse?.data?.amount === 0 ||
  //       paymentRersponse?.data?.subscriptionPlan?.toLowerCase() === 'free';
  //     if (!isFree) {
  //       window.location.href = paymentRersponse?.data?.url;
  //     }
  //   }
  // }, [paymentRersponse]);

  const baseKey = BUSINESS_KEYS[getMybusiness?.businessCode];

  const sideBarOpt = [
    {
      icon: 'assets/images/icons/sp-business/manage-business.svg',
      link: baseKey?.business,
      label: 'Manage Business',
    },
    // Full categories have their own service/banner/hours pages. "Lite"
    // categories (towing, taxi) don't — so give them a Manage Packages link
    // (this page) instead, keeping the sidebar consistent with their profile.
    baseKey?.service
      ? {
          icon: 'assets/images/icons/sp-business/manage-service.svg',
          link: baseKey.service,
          label: baseKey.label,
        }
      : {
          icon: 'assets/images/icons/sp-business/manage-service.svg',
          link: 'manage-package',
          label: 'Manage Packages',
        },
    baseKey?.banner && {
      icon: 'assets/images/icons/sp-business/banner.svg',
      link: baseKey.banner,
      label: 'Banner',
    },
    baseKey?.workingHours && {
      icon: 'assets/images/icons/sp-business/manage-working-hours.svg',
      link: baseKey.workingHours,
      label: 'Manage Working Hours',
    },
  ].filter(Boolean); // filters out any `false` or `undefined` entries

  const closeSuccessModal = () => {
    setShowSuccessModal(false);
  };

  console.log('getAllPlansList', getAllPlansList);

  return (
    <div>
      {/* <GaragesCommenHeader GarageFilterList={GarageFilterList} /> */}

      <div class="main-content-area">
        <div class="container">
          <div class="row justify-content-between">
            <Sidebar options={sideBarOpt} />

            <div class="col-12 col-sm-12 col-md-9 col-lg-9">
              <h2 class="mb-4">{t('Select Package')}</h2>

              <div class="row justify-content-center">
                {objArray !== undefined && objArray !== undefined ? (
                  objArray.map((x, i) => {
                    console.log('this is the all plant here', x);
                    const isFree =
                      x?.data?.amount === 0 ||
                      x?.data?.name?.toLowerCase() === 'free';

                    return (
                      <>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            flexWrap: 'wrap',
                            width: 'fit-content',
                          }}
                        >
                          <div class="sp-package sp-package-a">
                            <div
                              class="line-a"
                              style={{
                                height: '3rem',
                                width: '3rem',
                                borderRadius: '3rem',
                                backgroundColor: '#ffe399',
                                justifyContent: 'center',
                                display: 'flex',
                                margin: 'auto',
                                alignItems: 'center',
                                border: 'dotted #333333',
                              }}
                            >
                              {x?.name}
                            </div>
                            <div class="line-b">
                              {x?.data?.duration} {t('Days')}
                            </div>
                            <div
                              class="line-c"
                              style={{ textTransform: 'capitalize' }}
                            >
                              {x?.data?.name}
                            </div>
                            <div class="line-c">{x?.data?.text}</div>
                            <div class="line-d">
                              {x?.data?.amount} {x?.data?.currency?.toUpperCase()}
                            </div>
                            <div class="line-f">
                              <button
                                type="button"
                                class="btn btn-block btn-secondary"
                                href="#"
                                disabled={isFree && freeUsed}
                                style={
                                  isFree && freeUsed
                                    ? {
                                        opacity: 0.55,
                                        cursor: 'not-allowed',
                                      }
                                    : undefined
                                }
                                data-toggle={isFree ? '' : 'modal'}
                                onClick={() =>
                                  isFree && freeUsed
                                    ? null
                                    : handleBuyNowClick(x)
                                }
                                data-target={isFree ? '/' : '#payment-method'}
                              >
                                {isFree && freeUsed
                                  ? t('Already Availed')
                                  : t('Buy Now')}
                              </button>
                            </div>
                          </div>
                        </div>
                      </>
                    );
                  })
                ) : (
                  <>
                    {/* <h2>dsdasdfasdf</h2> */}
                    <div
                      className="text-center text-warning"
                      const
                      style={{
                        position: 'fixed',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                      }}
                    >
                      {/* [CF 2026-08-17] Page-level wait -> shared PageLoader.
                          The small in-button spinner further down stays a
                          Bootstrap spinner on purpose: the shared loader is 60px
                          and would not fit inside a button. */}
                      <PageLoader /> <br />
                    </div>
                  </>
                )}
              </div>

              {/* <!-- Payment Method --> */}
              <div
                class="modal fade"
                id="payment-method"
                tabindex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="exampleModalLabel">
                        {t('Payment Method')}
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        onClick={() => setPaymentMethod('')}
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-auto">
                          <button
                            type="button"
                            className={`payment-button btn ${
                              paymentMethod === 'KNET'
                                ? 'btn-warning'
                                : 'btn-outline-secondary'
                            }`}
                            onClick={() => setPaymentMethod('KNET')}
                          >
                            <img src="assets/images/icons/sp-packages/k-net.png" />{' '}
                            K-Net
                          </button>
                        </div>
                        <div class="col-auto">
                          <button
                            type="button"
                            className={`payment-button btn ${
                              paymentMethod === 'VISA'
                                ? 'btn-warning'
                                : 'btn-outline-secondary'
                            }`}
                            onClick={() => setPaymentMethod('VISA')}
                          >
                            <img src="assets/images/icons/sp-packages/credit-card.png" />{' '}
                            Visa / Master
                          </button>
                        </div>
                      </div>

                      <form class="mt-4">
                        <div class="form-group form-check">
                          <input
                            type="checkbox"
                            class="form-check-input"
                            id="exampleCheck1"
                            checked={termsAccepted}
                            onChange={(e) => setTermsAccepted(e.target.checked)}
                          />
                          <label
                            class="form-check-label"
                            htmlFor="exampleCheck1"
                          >
                            {t(
                              'By continuing you agreed to Terms and Conditions & Privacy Practices'
                            )}
                          </label>
                        </div>
                      </form>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        data-dismiss="modal"
                      >
                        {t('Cancel')}
                      </button>
                      {loading ? (
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : (
                        <button
                          type="button"
                          class="btn btn-primary"
                          onClick={onPayClickHandler}
                        >
                          {t('Pay')}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Payment Method --> */}

              {/* <!-- successfully Registered --> */}
              <div
                class={`modal fade ${showSuccessModal ? 'show' : ''}`}
                id="registration-done"
                style={{
                  display: showSuccessModal ? 'block' : 'none',
                  paddingRight: '17px',
                }}
                tabindex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden={!showSuccessModal}
              >
                <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title">Successfully Subscribed</h5>
                      <button
                        type="button"
                        class="close"
                        onClick={closeSuccessModal}
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <div class="row justify-content-center">
                        <div class="col-5">
                          <img
                            src="assets/images/icons/registration-done.svg"
                            class="img-fluid"
                            alt=""
                          />
                        </div>
                      </div>

                      <p class="mb-0 mt-4 text-center">
                        You have successfully subscribed to the Free plan
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- successfully Registered --> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuyPackages;
